import { Injectable } from '@angular/core';

/**
 * VDS-3315 — the reload seam. Two dumb methods and no logic: the branch lives
 * in the caller, not here, so this seam stays trivially stubbable in specs.
 *
 * The app runs on `HashLocationStrategy` (app.module.ts provides it, which wins
 * over `useHash: false` in `RouterModule.forRoot`), so a router URL like
 * `/app/dashboard` lives in the fragment: `https://host/#/app/dashboard`.
 * Assigning `/app/dashboard` as a real path would ask the server for it and
 * bootstrap nothing — a blank page. Hence `setHashUrl` writes the fragment, and
 * the caller always follows it with `reload()`: changing only the fragment is a
 * same-document navigation, and the full document load is what wipes the
 * previous building's in-memory state.
 */
@Injectable({
  providedIn: 'root',
})
export class BrowserNavigationService {
  reload(): void {
    window.location.reload();
  }

  setHashUrl(url: string): void {
    window.location.hash = url;
  }
}
